import { Component, Input } from '@angular/core';
import { ContractsWarrantiesService } from '../../../Services/contracts-warranties.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../Shared/Services/auth.service';
import { DtoWarrantyForViewVM } from '../../../Model/contracts-warranties/DtoWarrantyForViewVM';
import { UserInfoService } from '../../../Services/user-info.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoUserAndAgentVM } from '../../../Model/agents/DtoUserAndAgentVM';
import { environment } from '../../../../environments/environment'
import { DtoClientForViewVM } from '../../../Model/clients/DtoClientForViewVM';
import { UserType } from '../../../Shared/Enums/UserType';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { LoginVm } from '../../../Model/LoginVM';

@Component({
  selector: 'app-warranty-details',
  templateUrl: './warranty-details.component.html',
  styleUrl: './warranty-details.component.scss',
})
export class WarrantyDetailsComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  WarrantyDetailsInfo!: DtoWarrantyForViewVM;
  imgPath: string = environment.ImgUrl;
  UserInfo: DtoUserAndAgentVM = {};
  currentUser: LoginVm = {};

  constructor(private api: ContractsWarrantiesService, private route: ActivatedRoute, private auth: AuthService,
    private spinner: NgxSpinnerService, private toastrService: CustomToastrService, private userService: UserInfoService,
    private router: Router, private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.GetCurrentUser();
      this.route.params.subscribe(params => {
        const id = params['id'];
        this.WarrantyDetails(id);
      });

      this.GetUserInfo();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  GetUserInfo() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.userService.GetAgentInfo()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            if (data.isSuccess) {
              this.UserInfo = data.payload;
            }
          },
          error: (error: any) => {
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        })
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  WarrantyDetails(WarrantyId?: number) {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.api.GetWarrantyDetails(WarrantyId).subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            this.WarrantyDetailsInfo = data;
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  Cancel() {
    if (this.currentUser.userType == UserType.Client) {
      this.router.navigateByUrl('dashboard/warranties-list');
    }
    else {
      this.router.navigateByUrl('dashboard/contracts-warranties');
    }
  }
}
